module.exports = __webpack_public_path__ + "img/Z85-X18-中_03.3949223b.jpg";